import {
  GET_TRIBUN_NOTIFICATIONS_REQUEST,
  GET_TRIBUN_NOTIFICATIONS_SUCCESS,
  GET_TRIBUN_NOTIFICATIONS_FAILURE,
  GET_TRIBUN_NOTIFICATIONS_INITIAL_STATE
} from 'Store/constants';

const initialState = {
  data: [],
  lastPage: false,
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_TRIBUN_NOTIFICATIONS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_TRIBUN_NOTIFICATIONS_SUCCESS:
    {
      return {
        ...state, data: action.payload.length ? [...state.data, ...action.payload] : [],
        isLoading: false,
        error: null,
        lastPage: action.lastPage,
      };
    }
    case GET_TRIBUN_NOTIFICATIONS_FAILURE:
      return { ...state, lastPage: action.lastPage, isLoading: false, error: action.payload };
    case GET_TRIBUN_NOTIFICATIONS_INITIAL_STATE:
      return { ...initialState };
    default:
      return state;
  }
};
